import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker
,GetImgCertUser_CBack,RespBkMthdMapp_CBack} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';
import Comp_Marksheet_One from '../lms_component/comp_marksheet_one';
import Comp_Marksheet_Two from '../lms_component/comp_marksheet_two';
import Comp_View_Pdf from '../lms_component/comp_view_pdf';
import Comp_Sync_Study_Media from '../lms_component/comp_sync_study_media';
//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsCadetDataSync;

let rf="0";
class Cadet_Data_Sync extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stConsoldStudyMedia:[],stListClassFee:[],stSetHrfPdf:""};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsCadetDataSync=this;
      }

      // consolidate sync task Checklist
      getConsolidatedSyncedList(){
       
        var map=[];
        map.push({name:"curl_type",value:"getSyncedStateConsolidated"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});
       
        map.push({name:"sync_type",value:"officer_master"});
       
        map["res_func"]="callBackrrr";
        map["curl_type"]="getSyncedStateConsolidated";
        CallMapMethod_CBack(clsCadetDataSync,map,function(data,msg){
          //alert(msg);
          if(data!=="0"){
            let jsConsolid=JSON.parse(data);
            //alert(JSON.stringify(jsConsolid.study_media));
            clsCadetDataSync.setState({stConsoldStudyMedia:jsConsolid.study_media});
          }
        })
      }
      // End of Sync Task CheckList



      getOfficersSync(){
        var map=[];
        map.push({name:"curl_type",value:"VersionDataSync"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});
       
        map.push({name:"sync_type",value:"officer_master"});
       
        map["res_func"]="callBackrrr";
        map["curl_type"]="VersionDataSync";
        CallMapMethod_CBack(clsCadetDataSync,map,function(data,msg){
          if(data!=="0"){
            let syncData=JSON.parse(data);
            let officerMaster=syncData.officer_master;
            //alert(JSON.stringify(officerMaster));
            if (window.memc_system){
              let respStudy=  window.memc_system.getBulkOfficerImport(JSON.stringify(officerMaster));
              //alert(respStudy);
              Custom_Alert("View",respStudy,false);
            }

          }

        })

      }
   
      getStudyMasterialSyncTask(){
        var map=[];
        map.push({name:"curl_type",value:"VersionDataSync"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"upper_id",value:userObject[0].upper_id});
       
        map.push({name:"sync_type",value:"study_material"});
       
        map["res_func"]="callBackrrr";
        map["curl_type"]="VersionDataSync";
        CallMapMethod_CBack(clsCadetDataSync,map,function(data,msg){
          //alert(data);
          if(data!=="0"){
            let syncData=JSON.parse(data);
            let studyMaterial=syncData.study_material;
            let studyCatMaster=syncData.study_category_master;
            //alert(studyMaterial.length);
            if (window.memc_system){
             let respStudy=  window.memc_system.getBulkImport(JSON.stringify(studyMaterial));
             let respCategory=window.memc_system.getBulkCategoryImport(JSON.stringify(studyCatMaster));
             
             Custom_Alert("Successfully","Completed Successfully",false);
            }
            
          }
        })
      }


      
       
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getConsolidatedSyncedList();

}




      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
   
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card card-secondary">
              {/* <!-- /.card-header --> */}
           <div class="card-header">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Offline/Online Stage 1.</b></h3>
                
              </div>
              
            <div className="card-body">
              <table className='dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive'>
                <thead>
                    <th>Module/Event</th>
                    <th>Description</th>
                    <td>Action</td>
                </thead>
                <tbody>
                    {/* <tr>
                        <td><b>Officers Import</b></td>
                        <td>Option will sync newly added officers for your training</td>
                        <td><button onClick={()=>this.getOfficersSync()} type="button">Officer Sync</button></td>
                    </tr> */}
                    <tr>
                        <td>1. <b>Semesters Task</b></td>
                        <td>Option will sync Task assigned by MTO</td>
                        <td><button onClick={()=>this.getStudyMasterialSyncTask()} class="btn btn-primary" type="button">Download Task</button></td>
                    </tr>
                    <tr>
                        <td>2. <b>Task Related Media</b></td>
                        <td>Option will sync Study/Task media files to tab</td>
                        <td><a class="btn btn-danger" href={"javascript:void(0)"} data-bs-toggle="modal" data-bs-target='#divSyncStudyMedia' data-toggle="modal" data-target="#divSyncStudyMedia">Download Media</a></td>
                    </tr>
                    {/* <tr>
                        <td>3. <b>Submitted Task</b></td>
                        <td>Sync all Task submitted by Me</td>
                        <td><button type="button">NA (not required)</button></td>
                    </tr> */}
                  

                </tbody>
                </table>         
                                      
            </div>   
            </div>
            {/* End of Stage 1  */}

            <div class="card card-secondary">
              {/* <!-- /.card-header --> */}
           <div class="card-header">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Offline/Online List.</b></h3>
                
              </div>
              
            <div className="card-body">
              <table className='dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive'>
                <thead>
                    <th>Module/Event</th>
                    <th>NOS Total</th>
                    <th>NOS Synced</th>
                    <th>NOS Pending</th>
                    <td>Action</td>
                </thead>
                <tbody>
                    <tr>
                        <td><b>Task Files</b></td>
                        <td>NOS Total</td>
                        <td>NOS Synced</td>
                        <td>NOS Pending</td>
                        <td><a href={"javascript:void(0)"} data-bs-toggle="modal" data-bs-target='#divSyncStudyMedia' data-toggle="modal" data-target="#divSyncStudyMedia" class="btn btn-danger">Sync Pending</a></td>
                    </tr>
                 
                    {/* <tr>
                        <td><b>Submitted Task</b></td>
                        <td>Sync all Task submitted by Me</td>
                        <td><button type="button">Sync Now</button></td>
                    </tr> */}
                  

                </tbody>
                </table>         
                                      
            </div>   
            </div>
      </div>
</div>
</div>
</div>
<Comp_Sync_Study_Media studyMedia={this.state.stConsoldStudyMedia} userObject={userObject}/>
<Comp_View_Pdf hrfPdf={this.state.stSetHrfPdf} proItem={this.state.stItemProduct} />
<Alert_Content/>
<Footer/>

    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Cadet_Data_Sync;